var _excluded = ["children", "className", "dismissable", "level", "onClose", "fitContentWidth"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { keyCodes } from "../../utils/helpers";
import AIcon from "../AIcon";
import "./AAlert.scss";
var AAlert = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    _ref$dismissable = _ref.dismissable,
    dismissable = _ref$dismissable === void 0 ? true : _ref$dismissable,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? "info" : _ref$level,
    onClose = _ref.onClose,
    _ref$fitContentWidth = _ref.fitContentWidth,
    fitContentWidth = _ref$fitContentWidth === void 0 ? false : _ref$fitContentWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dismissableKeyDownHandler = function dismissableKeyDownHandler(e) {
    if (onClose && [keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
      e.preventDefault();
      onClose(e);
    }
  };
  var className = "a-alert focus-box-shadow a-alert--state-",
    icon = "";
  switch (level) {
    case "success":
      className += "success";
      icon = "positive";
      break;
    case "warning":
      className += "warning";
      icon = "warning";
      break;
    case "danger":
      className += "danger";
      icon = "negative";
      break;
    default:
      className += "information";
      icon = "info";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (fitContentWidth) {
    className += " a-alert--fit-content-width";
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    role: "alert",
    ref: ref,
    className: className
  }), /*#__PURE__*/React.createElement(AIcon, {
    className: "a-alert__icon a-alert__icon--level",
    size: 19.5
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "a-alert__message"
  }, children), dismissable && /*#__PURE__*/React.createElement(AIcon, {
    className: "a-alert__icon focus-box-shadow a-alert__icon--close",
    onClick: function onClick(e) {
      return onClose && onClose(e);
    },
    onKeyDown: dismissableKeyDownHandler,
    size: 16,
    tabIndex: 0
  }, "x"));
});
AAlert.propTypes = {
  /**
   * Toggles the close button.
   */
  dismissable: PropTypes.bool,
  /**
   * Specifies the display variant.
   */
  level: PropTypes.oneOf(["info", "success", "warning", "danger"]),
  /**
   * A callback for handling the close event.
   */
  onClose: PropTypes.func,
  /**
   * Unset default width: 100% on the alert.
   */
  fitContentWidth: PropTypes.bool
};
AAlert.displayName = "AAlert";
export default AAlert;